import { Scanner } from '@yudiel/react-qr-scanner'
import { memo } from 'react'

const CONFIG = {
    constraints: {
        aspectRatio: 1,
    },
    scanDelay: 2000,
    allowMultiple: true,
}

const TicketScanner = ({ paused, onScan }) => <Scanner {...CONFIG} paused={paused} onScan={onScan} />

/**
 * Memoized version of TicketScanner to prevent performance issues.
 * This is crucial for Scanner component which handles video stream and should not re-render
 * on every keystroke in the input field.
 */
export const MemoizedTicketScanner = memo(
    TicketScanner,
    (prevProps, nextProps) => prevProps.paused === nextProps.paused
)
